// BulkActionBar.js - Bulk action bar for selected inventory items
import React, { useState } from 'react';
import './BulkActionBar.css';

function BulkActionBar({
    selectedCount,
    onClearSelection,
    onSuppress,
    onExport,
    loading
}) {
    const [actionLoading, setActionLoading] = useState(null);

    const handleSuppress = async () => {
        setActionLoading('suppress');
        try {
            await onSuppress();
        } finally {
            setActionLoading(null);
        }
    };

    const handleExport = async (format) => {
        setActionLoading(`export-${format}`);
        try {
            await onExport(format);
        } finally {
            setActionLoading(null);
        }
    };

    if (selectedCount === 0) {
        return null;
    }

    return (
        <div className="bulk-action-bar">
            <div className="bulk-action-info">
                <span className="bulk-check-icon">✓</span>
                <span className="bulk-count">{selectedCount} selected</span>
            </div>

            <div className="bulk-actions">
                <button
                    className="bulk-btn bulk-btn-suppress"
                    onClick={handleSuppress}
                    disabled={loading || actionLoading}
                >
                    {actionLoading === 'suppress' ? (
                        <span className="btn-loading"></span>
                    ) : (
                        <span className="btn-icon">🔇</span>
                    )}
                    Suppress
                </button>

                <button
                    className="bulk-btn bulk-btn-export"
                    onClick={() => handleExport('csv')}
                    disabled={loading || actionLoading}
                >
                    {actionLoading === 'export-csv' ? (
                        <span className="btn-loading"></span>
                    ) : (
                        <span className="btn-icon">📤</span>
                    )}
                    Export CSV
                </button>

                <button
                    className="bulk-btn bulk-btn-clear"
                    onClick={onClearSelection}
                    disabled={loading || actionLoading}
                >
                    Clear
                </button>
            </div>
        </div>
    );
}

export default BulkActionBar;
